module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/indiana-university-1be346329e9cfb22aee62e6211db2a0d.svg";